import React from 'react';

import { IconButton, Tooltip } from '@mui/material';

import { useDispatch } from 'react-redux';
import * as NotificationActions from 'actions/NotificationActions';
import { useTranslation } from 'services/localization';
import { RiFileCopyLine } from 'react-icons/ri';

interface Props {
	text: string;
	showTooltip: boolean;
	showCopyNotification: boolean;
	onCopyDone?: (success: boolean) => void;
}

const CopyToClipboardIcon = (props: Props) => {
	const { text, showTooltip, showCopyNotification } = props;
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(text);
			if (showCopyNotification) {
				dispatch(
					NotificationActions.showNotification({
						message: t('common:actions.copiedToClipboard', 'Copied to clipboard'),
						variant: 'info',
						autoDismissMs: 1000,
					}),
				);
			}
			props.onCopyDone?.(true);
		} catch (e) {
			if (showCopyNotification) {
				dispatch(
					NotificationActions.showNotification({
						message: t('common:errors.error'),
						variant: 'error',
						autoDismissMs: 1000,
					}),
				);
			}
			props.onCopyDone?.(false);
		}
	};

	return (
		<Tooltip title={showTooltip ? t('common:actions.copyToClipboard', 'Copy to clipboard') : ''}>
			<IconButton onClick={handleCopy} size="small">
				<RiFileCopyLine size={18} />
			</IconButton>
		</Tooltip>
	);
};

export default CopyToClipboardIcon;
